import React, { useState } from 'react';
import axios from 'axios';
import { Upload } from 'lucide-react';
import './EncoderComponent.css';

function EncoderComponent() {
  const [file, setFile] = useState(null);
  const [templateImage, setTemplateImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [encodedImage, setEncodedImage] = useState(null);

  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleTemplateChange = (e) => setTemplateImage(e.target.files[0]);

  const handleUpload = async () => {
    if (!file) {
      alert('Please upload a file to encode');
      return;
    }
    
    const formData = new FormData();
    formData.append('file', file);
    if (templateImage) {
      formData.append('template_image', templateImage);
    }

    setLoading(true);
    setEncodedImage(null);

    const baseUrl = process.env.REACT_APP_BE_URL || 'https://datamask-api.onrender.com';

    try {
      const response = await axios.post(`${baseUrl}/encode`, formData, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      setEncodedImage(URL.createObjectURL(blob));
    } catch (error) {
      alert('Error encoding file');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="encoder-main">
      <div className="encoder-card">
        <h2 className="encoder-title">Encode a File</h2>
        <div className="upload-container">
          <div className="upload-section">
            <label className="upload-label">Upload File to hide:</label>
            <div className="upload-area">
              <label className="upload-box">
                <Upload className="upload-icon" />
                <span className="upload-text">
                  {file ? file.name : 'Choose a file or drag it here'}
                </span>
                <input type="file" className="hidden" onChange={handleFileChange} />
              </label>
            </div>
          </div>

          <div className="upload-section">
            <label className="upload-label">Upload Template Image (optional):</label>
            <div className="upload-area">
              <label className="upload-box">
                <Upload className="upload-icon" />
                <span className="upload-text">
                  {templateImage ? templateImage.name : 'Choose an image or drag it here'}
                </span>
                <input 
                  type="file" 
                  className="hidden" 
                  accept="image/*"
                  onChange={handleTemplateChange}
                />
              </label>
            </div>
          </div>

          <button className="upload-button" onClick={handleUpload}>
            Upload
          </button>
        </div>

        {loading && <div className="progress">Encoding in progress...</div>}
        {encodedImage && (
          <div className="result">
            <img src={encodedImage} alt="Encoded preview" />
            <a href={encodedImage} download="encoded_image.png">Download Encoded Image</a>
          </div>
        )}
      </div>
    </main>
  );
}

export default EncoderComponent;
